/* eslint-disable no-console,no-undef */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { getWorkAnniversary } from '../../redux/actions';
import { BirthdayCardUpdate, FeedCardWrapper, UserInitialsMain } from "./styles";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ImageUrl } from '../../utils/constants';
import { Divider } from "../Manager/styles";
import { getInitials } from "../../utils/methods";

class AnniversaryWishCard extends Component {
  constructor(props) {
    super(props);
  }

  // componentDidMount(){
  //   const { getWorkAnniversary } = this.props;
  //   getWorkAnniversary();
  // }

  fallBack = (e) => {
    e.target.src = "/public/images/neutral_avatar.svg";
  };

  containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  }


  render() {
    const { birthdayList, callback } =this.props;
    let anniversary = []
    if(birthdayList?.today_anniversary){
      anniversary=[ ...birthdayList.today_anniversary, ...birthdayList.recent_anniversary, ...birthdayList.upcoming_anniversary];
    }
    return (
      <>
        {anniversary.length > 0 ? <FeedCardWrapper margin="20px" height="216px" padding="0px 16px">
          <div className='heading'>
            <div className='title-updated'>Work Anniversaries</div>
          </div>
          <Divider isMargin={'8px 16px 12px 16px'}></Divider>
          <div className='wrapper'>
            <BirthdayCardUpdate isWidth={"80px"} isHeight={"80px"}>
              <div className="images">
                {anniversary?.slice(0,3)?.map((data,index)=>(
                  index==0?
                    <div className="image" key={index}>
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" +data.profile_image}/>:
                        <UserInitialsMain border isWidth={"80px"} isHeight={"80px"} size={"24px"} isBg color="#184A61">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>:
                    <div className="imageLeft" key={index}>
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" +data.profile_image}/>:
                        <UserInitialsMain border isWidth={"80px"} isHeight={"80px"} size={"24px"} isBg color="#184A61">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                ))}
              </div>
              <div className="button" id="warm-wishes" onClick={() => callback()}>Share Your Warm Wishes</div>
            </BirthdayCardUpdate>
          </div>
        </FeedCardWrapper> : null}
      </>
    );
  }
}

AnniversaryWishCard.propTypes = {
  birthdayList: PropTypes.array,
  getWorkAnniversary: PropTypes.func,
  history: PropTypes.object,
  t: PropTypes.func,
  callback: PropTypes.func
};
const mapStateToProps = (state) => ({
  birthdayList: state.profileData.workAnniversaryList
})
const mapDispatchToProps = (dispatch) => ({
  getWorkAnniversary: () => dispatch(getWorkAnniversary())
})
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AnniversaryWishCard));
